import React, { useState } from 'react';
import { connect } from 'react-redux';
import { QRCodeSVG } from 'qrcode.react';

import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';

import Button from '../shared/Button';
import Alert from '../shared/Alert';
import Modal from './Modal';

import { withFirebase } from '../../firebase';

import '../dashboard/dashboard.scss';

const issuer = 'PersonalisedSurgery';

const EnableTOTPModal = (props) => {
  const {
    open,
    onClose,
    firebase,
    email,
    userName,
    onSuccess,
    multiFactorEnabled,
  } = props;

  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  const [showQR, setShowQR] = useState(false);
  const [qrCodeUrl, setQRCodeUrl] = useState('');
  const [secret, setSecret] = useState(null);

  const [otp, setOtp] = useState('');

  const onSubmit = async () => {
    setLoading(true);
    try {
      if (!!password) {
        if (!!multiFactorEnabled) {
          await firebase.disable2FA(password);
        }

        const res = await firebase.generateTOTPSecret(password);
        if (res && res?.secretKey) {
          const url = `otpauth://totp/${issuer}:${email}?secret=${res.secretKey}&issuer=${issuer}`;
          setSecret(res);
          setQRCodeUrl(url);
          setShowQR(true);
        }
      }
    } catch (err) {
      setError('Something went wrong. Please contact administrator.');
    } finally {
      setLoading(false);
    }
  };

  const onVerifyOtp = async () => {
    setLoading(true);
    try {
      await firebase.verifyTOTP(otp, secret, userName);
      setShowQR(false);
      onSuccess();
      onClose();
    } catch (err) {
      setError('Invalid OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        onClose();
        setPassword('');
        setOtp('');
      }}
      onSubmit={onSubmit}
      title="Enable Authenticator 2FA"
    >
      {showQR && !!qrCodeUrl ? (
        <div className='p-lg'>
          <div className='m-b-lg'>Scan this QR code with your authenticator app:</div>
          <QRCodeSVG value={qrCodeUrl} size={200} />

          <div className="p-t-lg">
            <TextField
              id="otp"
              type="text"
              label="Enter Passcode"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              fullWidth
            />
            <div className="actions m-t-lg d-flex flex-end">
              <Button text="Verify" color="primary" onClick={onVerifyOtp} disabled={loading} loading={loading} />
            </div>
          </div>
        </div>
      ) : (
        <div className="p-lg">
          <div className='secondary m-b-md'>You have to re-enter your current password to enable multi-factor authentication</div>
          <Grid container spacing={0}>
            <Grid size={{ xs: 12, md: 12 }}>
              <div className="p-t-md">
                <TextField
                  id="password"
                  type="password"
                  label="Current password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                  fullWidth
                />
              </div>
            </Grid>
          </Grid>
          <div className="actions m-t-lg d-flex flex-end">
            <Button
              text="Submit"
              color="primary"
              onClick={onSubmit}
              disabled={loading}
              loading={loading}
            />
          </div>
        </div>
      )}

      <Alert variant="error" message={error} open={!!error} onClose={() => setError(null)} />
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    email: state.user.currentUser.email,
    userName: `${state.user.currentUser.firstName} ${state.user.currentUser.lastName}`,
    multiFactorEnabled: state.user?.currentUser?.multiFactorEnabled,
  };
};

export default connect(mapStateToProps)(withFirebase(EnableTOTPModal));
